import axios, { AxiosError, AxiosResponse } from 'axios'
import { StatusCode } from '@/constants/statusCode'

const BASE_URL = ''
const TIMEOUT = 60000

let _onUnauthorized: (() => void) | null = null
let _isAuthenticated = false

export function setOnUnauthorized(cb: () => void) {
  _onUnauthorized = cb
}

export function setAuthenticated(value: boolean) {
  _isAuthenticated = value
}

const transformRequestOptions = (params: any) => {
  let options = ''
  for (const key in params) {
    if (typeof params[key] !== 'object' && params[key]) {
      options += `${key}=${params[key]}&`
    } else if (typeof params[key] === 'object' && params[key] && params[key].length) {
      params[key].forEach((el: any) => {
        options += `${key}=${el}&`
      })
    }
  }
  return options ? options.slice(0, -1) : options
}

const request = axios.create({ withCredentials: true })

request.interceptors.request.use((config) => {
  config.paramsSerializer = (params) => transformRequestOptions(params)
  config.baseURL = BASE_URL
  config.timeout = TIMEOUT
  config.headers.set('X-Requested-With', 'XMLHttpRequest')
  return config
})

request.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.status === StatusCode.NoContent) {
      return null
    }
    return response.data
  },
  (error: AxiosError) => {
    if (_isAuthenticated && isAuthError(error)) {
      _isAuthenticated = false
      _onUnauthorized?.()
      return Promise.reject(error.response)
    }
    return Promise.reject(error)
  },
)

function isAuthError(error: AxiosError): boolean {
  return error.response?.status === 401
}

const api = {
  get<T = any>(url: string, config?: any): Promise<T> {
    return request.get(url, config) as any
  },
  post<T = any>(url: string, data?: any, config?: any): Promise<T> {
    return request.post(url, data, config) as any
  },
  put<T = any>(url: string, data?: any, config?: any): Promise<T> {
    return request.put(url, data, config) as any
  },
  delete<T = any>(url: string, config?: any): Promise<T> {
    return request.delete(url, config) as any
  },
}

export default api
